import { AuthType } from '@web/types/api'
import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseApi } from './createBaseApi'

export const appApi = createApi({
  reducerPath: 'appApi',
  baseQuery: createBaseApi({
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 60000,
    baseUrl: import.meta.env.VITE_API_URL,
    demoUrl: import.meta.env.VITE_DEMO_URL,
    authTokenPath: 'token' as const,
    // apiName: 'ApiNameForDebug',
    // debug: true,
  }),
  tagTypes: [
    'contents',
    'content',
    'scopes',
    'content-scope',
    'content-scope-details',
    'parameters',
    'Documents',
    'Universities',
    'Faculties',
    'Templates',
    'Careers',
    'Users',
    'Profile',
    'ApiKeys',
    'Permissions',
    'EmailConfig',
    'Folders',
    'Trash',
  ],
  endpoints: (builder) => ({
    refreshToken: builder.mutation<AuthType, { refresh_token: string }>({
      query: (token) => ({
        url: `/api/v1/auth/refresh`,
        method: 'POST',
        body: token,
      }),
      extraOptions: {
        unauthenticated: true,
      },
    }),
  }),
})
